import "./StreamingVPNs.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Streamingvpngrid from "./sections/Streamingvpngrid";
import Faq from "./sections/Faq";
import Streaminginsightsblog from "./sections/Streaminginsightsblog";
import Streamingaccesscta from "./sections/Streamingaccesscta";
import AffiliateStreamingCTA from "./sections/AffiliateStreamingCTA";
import Relatedpostsstreaming from "./sections/Relatedpostsstreaming";
import Footer from "@/reusable_sections/Footer";
export default function StreamingVPNsPage() {
  return <div>
      <Header />
      <Hero />
      <Streamingvpngrid />
      <Faq />
      <Streaminginsightsblog />
      <Relatedpostsstreaming />
      <Streamingaccesscta />
      <AffiliateStreamingCTA />
      <Footer />
    </div>;
}